<template>
    <div>

        <video 
            src="http://techslides.com/demos/sample-videos/small.mp4" 
            id="video"
            playsinline
            loop
            autoplay
            muted   
            style="display:none"    
        >
            
        </video>

        <div> message that checks if your are on mobile or not</div>

        <div id="thiscanvas" ref='canvas' />
        <div id= "leaveRoom">
            <button id ="leaveRoom"
                v-show="roomConnection != null && loading == false"
                v-on:click="$emit('changeRoom')"
                >Leave Room</button>
        </div>

        <div id= "controls">
            <Geolocation/>

            <button v-on:click="turnOnCamera()"> {{cameraMessage}}</button>

            <!-- Local Video Tracks -->
            <div :key="reRenderLocal">
                <div
                    v-for="(track, t_index) in roomConnection.localParticipant.videoTracks"
                    :key="track.key"
                >
                    
                    <div id="videocontainer">Hier komt de video {{t_index}}</div>
                    <SphereVideoTrack
                        :participantkey="'you'"
                        :publication="track"
                        :trackindex="t_index"
                    />
                </div>
            </div>   



        <div>turn on microphone</div>
        </div>
        
    </div>
</template>

<script>

import * as THREE from 'three';
import TrackballControls from 'three-trackballcontrols'
import Geolocation from './Geolocation'
import Twilio, {
  connect,
  createLocalTracks,
  createLocalVideoTrack,
  createLocalAudioTrack,
} from "twilio-video"

import Videotrack from '../Videotrack'
import SphereVideoTrack from './SphereVideoTrack'

export default {
    name: 'TheCanvas',
    props: ["roomConnection","loading","cameraOptions"],
    components:{
        Geolocation,
        SphereVideoTrack
        // Videotrack
    },

    data: function() {
        const scene = new THREE.Scene()
        // const composer = new THREE.EffectComposer(new WebGLRenderer())
        // const effectPass = new THREE.EffectPass(camera, new BloomEffect())
        const camera = new THREE.PerspectiveCamera(
            75,
            window.innerWidth / window.innerHeight,
            0.1,
            1000
        )


        const renderer = new THREE.WebGLRenderer({ antialias: true })
        const light = new THREE.DirectionalLight('hsl(0, 100%, 100%)') // Hier gebruikt Ting een ambientlight, weet niet of dat veel veschilt maakt.

        // const geometry = new THREE.BoxGeometry(1, 1, 1)
        const geometry = new THREE.SphereBufferGeometry(2,30,30);

        // const texture = new THREE.TextureLoader().load( 'https://api.enter.hetnieuweinstituut.nl/uploads/ball_texture_434d1e834c.jpeg' );
        const texture = new THREE.TextureLoader().load( 'https://api.enter.hetnieuweinstituut.nl/uploads/ball_texture_434d1e834c.jpeg' );


        // const video = document.getElementById("video");
        // const videoTexture = new THREE.VideoTexture(video);

        // videoTexture.minFilter = THREE.LinearFilter;
        // videoTexture.magFilter = THREE.LinearFilter;

        // const movieMaterial = new THREE.MeshBasicMaterial({
        //     map:videoTexture,
        //     side: THREE.FrontSide,
        //     toneMapped:false,
        // });

        // const movieGeometry = new THREE.BoxGeometry(100,100,100);

        // const movieCubeScreen = new THREE.Mesh(movieGeometry,movieMaterial);


        const material = new THREE.MeshBasicMaterial( { map: texture} );

        const cube = new THREE.Mesh(geometry, material)
        const axes = new THREE.AxesHelper(5)

        const line = new THREE.LineSegments(
        new THREE.WireframeGeometry(geometry),
        new THREE.LineBasicMaterial({
            color: 0xffffff,
            linewidth: 1,
            opacity: 0.5,
            transparent: true
        })
   );

        return {
            scene: scene,
            camera: camera,
            controls: [],
            renderer: renderer,
            light: light,
            cube: cube,
            axes: axes,
            speed: 0.001,
            line:line,
            localCamera: null,
            cameraButtonDisabled: false,
            localIndex: 0,
            reRenderLocal: 0,
            isCameraOn: false,
            cameraMessage: "Turn on camera",
            // movieCubeScreen:movieCubeScreen

        }
    },
    created: function() {
        
        // console.log("Created:",this.cameraOptions);
        this.scene.add(this.camera)
        this.scene.add(this.light)
        this.scene.add(this.cube)
        this.scene.add(this.line);
        // this.scene.add(this.videoScreen);
        // this.scene.add(this.movieCubeScreen);

        // this.scene.add(this.axes)

        this.renderer.setSize(window.innerWidth, window.innerHeight)
        //this.renderer.setSize(500,500)
        // this.renderder.setPixelRatio(window.devicePixelRatio)
        // this.renderer.setClearColor(0x00000,1)
        // this.movieCubeScreen.position.set(0,50,0);
        // this.light.position.set(0, 0, 10)
        // this.camera.position.set(0,150,300);
        // this.camera.lookAt(this.movieCubeScreen.position);
        // this.camera.position.z = 5
        this.camera.position.set(0,0,5);

        this.scene.background = new THREE.Color('hsl(0, 100%, 100%)')
        this.controls = new TrackballControls(this.camera)
        this.controls.rotateSpeed = 1.0
        this.controls.zoomSpeed = 5
        this.controls.panSpeed = 0.8
        this.controls.noZoom = false
        this.controls.noPan = false
        this.controls.staticMoving = true
        this.controls.dynamicDampingFactor = 0.3
    },
    mounted: function() {
        this.$refs.canvas.appendChild(this.renderer.domElement)
        this.animate()
    },
    methods: {
        animate: function() {
            requestAnimationFrame(this.animate)
            this.renderer.render(this.scene, this.camera)
            this.cube.rotation.y += this.speed
            // this.controls.update()


            // this.annotation.style.top = `${this.vector.y}px`;
            // this.annotation.style.left = `${this.vector.x}px`;
            // this.annotation.style.opacity = spriteBehindObject ? 0.25 : 1;

            // this.vector.y++

            // console.log(this.annotation);

        },

        turnOnCamera() {

            
            const VueThis = this;
            
            if (VueThis.localCamera == null) {
                VueThis.cameraButtonDisabled = true;
                createLocalTracks({ audio: false, video: { deviceId: this.cameraOptions[0].deviceId } }).then((track) => {
                    VueThis.localIndex += 1;
                    VueThis.roomConnection.localParticipant.publishTrack(track[0]);
                    // console.log(typeof(VueThis.roomConnection.localParticipant.tracks))
                    VueThis.localCamera = track[0];
                    setTimeout(function () {
                        VueThis.reRenderLocal += 1;
                        VueThis.reRender += 1;
                        VueThis.cameraMessage = "Turn off camera";
                        VueThis.isCameraOn  = true;
                        VueThis.cameraButtonDisabled = false;
                    }, 1000);
                });
            } else {
                this.turnOffCamera();
            }


            console.log(this.roomConnection.localParticipant.videoTracks);
            console.log(this.roomConnection.localParticipant.videoTracks.key);

            let videocontainer = document.getElementById('videoContainer');

            videocontainer.appendChild(this.$props.publication[1].track.attach());

            
        },
        
        turnOffCamera() {
            const VueThis = this;
            VueThis.cameraMessage = "Turn on camera";
            VueThis.localCamera.stop();
            VueThis.roomConnection.localParticipant.unpublishTrack(VueThis.localCamera);
            VueThis.localCamera = null;
            VueThis.reRenderLocal += 1;
            // VueThis.reRender += 1;
            VueThis.isCameraOn = false;
        },
        
         

    },
    computed: {
        rotate: function() {
            if (this.speed === '') {
                return 0
            } else {
                return this.speed
            }
        }
    },


    watch: {
        /*
      localCamera: function () {
        
        console.log ("modified field");
        console.log(this.localCamera);


        // const video = document.getElementById( 'video' );
        // const texture = new THREE.VideoTexture( video );

        console.log(this.localCamera);


        const geometry = new THREE.SphereBufferGeometry(2,30,30);
        const t = new THREE.VideoTexture(this.localCamera.mediaStreamTrack);
        // console.log(texture);

        // const texture = new THREE.TextureLoader().load( 'https://api.enter.hetnieuweinstituut.nl/uploads/TEXTURE_height_8717e1adb9.jpg' );
        // const texture = new THREE.TextureLoader().load( 'http://techslides.com/demos/sample-videos/small.mp4' );
        const material = new THREE.MeshBasicMaterial( { map: t} );

        const cube = new THREE.Mesh(geometry, material)

        this.scene.add(cube)

      }


      */
    }




}

</script>

<style>

    canvas{
    width: 500px;
    height: 500px;
    }

    #leaveRoom{
        position: fixed;
        bottom: 10px;
        right: 5%;
        z-index:1000;
        text-align: right;
        color:rgb(235, 235, 235);
        background-color: #464646;
    }

    #leaveRoom:hover{
        background-color:purple;
    }


    #controls{
        position: fixed;
        bottom: 10px;
        left: 5%;
        z-index:1000;
        text-align: left;
        background:green;
    }

    #controls div{
        color: white;
    }

    #controls div:hover{
        /* background-color:purple; */
        /* color:white; */
        
    }

</style>